
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.59 6.47l-6.367-3.392a.66.66 0 00-.629.004l-6.19 3.392a.661.661 0 00-.344.58v4.803a9.521 9.521 0 005.706 8.713l.86.375a.659.659 0 00.526 0l.967-.417a9.502 9.502 0 005.82-8.76V7.054a.66.66 0 00-.35-.583z"}})])
          )
        }
      }
    